import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogProps,
} from 'app/design-lib';
import AudioEditor from 'app/components/AudioEditor/AudioEditor';

interface GreetingDialogProps extends Omit<DialogProps, 'children'> {
  greeting_id?: string;
  onComplete: (greeting_id: string) => void;
  isLoading?: boolean;
}

export const VmboxGreetingDialog = ({
  open,
  onClose,
  greeting_id,
  onComplete,
  isLoading,
}: GreetingDialogProps) => {
  return (
    <Dialog size={'2xl'} open={open} onClose={onClose}>
      <GreetingContent
        isLoading={isLoading}
        greeting_id={greeting_id}
        onClose={onClose}
        onComplete={onComplete}
      />
    </Dialog>
  );
};

const GreetingContent = ({ greeting_id, onComplete, onClose, isLoading }) => {
  return (
    <>
      <DialogHeader title={'Voicemail Greeting'} onClose={onClose} />
      <DialogContent className={`overflow-y-visible`}>
        <AudioEditor
          isLoading={isLoading}
          loadingLabel={`Updating greeting...`}
          hideCancel
          mediaName={`voicemail_greeting_${Date.now()}`}
          mediaId={greeting_id}
          onComplete={onComplete}
          subType={'vmbox-greeting'}
          onClose={onClose}
          hasPlatformDefault={false}
        />
      </DialogContent>
    </>
  );
};
